import {forwardRef} from 'react';
import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import {object} from 'yup';

import {Button, Form} from '#component/base';
import {TextInputField} from '#component/partial';
import {emailValidator, handleValidationError} from '#util/validator';
import {ValidationError} from '#util/validator/handleValidationError';

import {FieldValues, RequestCreateAccountLinkFormProps} from './RequestCreateAccountLink.types';

export const RequestCreateAccountLinkForm = forwardRef<
  HTMLFormElement,
  RequestCreateAccountLinkFormProps
>(({className, onSubmit, pageState, ...otherProps}, ref) => {
  const {
    clearErrors,
    formState: {errors, isSubmitting},
    handleSubmit,
    register,
    setError,
  } = useForm({
    defaultValues: {form: '', email: ''},
    mode: 'onBlur',
    resolver: yupResolver(object({email: emailValidator})),
  });

  const _handleSubmit = async (fieldValues: FieldValues) => {
    try {
      await onSubmit?.(fieldValues);
    } catch (error) {
      handleValidationError({
        error: error as unknown as ValidationError<FieldValues>,
        errorMessages: {
          form:
            error instanceof Error
              ? error.message
              : 'Unable to request account creation link. Please try again.',
        },
        setError,
      });
    }
  };

  return (
    <Form
      className={className}
      clearErrors={clearErrors}
      errors={errors}
      onSubmit={onSubmit ? handleSubmit(_handleSubmit) : undefined}
      ref={ref}
      {...otherProps}>
      <TextInputField errors={errors} label="e-mail" defaultValue={''} {...register('email')} />
      <Button disabled={isSubmitting} type="submit">
        Send Create Account Link
      </Button>
    </Form>
  );
});
